export const RUOLI_DISPONIBILI = [
    { label: 'Admin', value: 'administrator', priority: 0, writePermissions: true, pricingDetails: true },
    { label: 'Manager', value: 'manager', priority: 1, writePermissions: true, pricingDetails: true },
    { label: 'Ufficio', value: 'content_editor', priority: 2, writePermissions: true, pricingDetails: true },
    { label: 'Agente', value: 'agente', priority: 3, writePermissions: false, pricingDetails: false },
    { label: 'Cliente', value: 'cliente', priority: 3, writePermissions: false, pricingDetails: false },
    { label: 'No Role', value: 'no-role', priority: 4, writePermissions: false, pricingDetails: false }
]